import SearchResultComponent from './SearchResult.component';
import SearchResultLoader from './SearchResultLoader';

const SearchResult = Object.assign(SearchResultComponent, { Loading: SearchResultLoader });

export default SearchResult;
